<template>
  <modal
    class="modal"
    name="set-name-artist-modal"
    transition="pop-out"
    :width="modalWidth"
    :height="260"
    :adaptive="true"
    :clickToClose="false"
    @before-open="beforeOpen"
  >
    <div class="flex flex-column items-center justify-center w-100 h-100">

      <div class="h2 heigthMobile">
        <clip-loader :loading="isLoadingLink" :color="color" :size="size"></clip-loader>
      </div>

    <div class="custom-padding">
      <div class="text-center mb-3">
        <p class="flex items-center flex-wrap justify-center dn f3">{{ $t("users.userType.flowArtist.artisticName") }}</p>
          <div class="custom-padding-input">
            <input
              type="text"
              id="name"
              v-model="nameNeeded"
              maxlength="50"
              class="form-control dark-text-color"
              @input="validateName"
            />
          </div>
        <p v-if="nameError" class="error">{{ nameError }}</p>
        <p class="w-100 tc textColor">{{ $t("users.userType.flowArtist.text") }}</p>
      </div>
    </div>

      <div class="mb-4 flex items-center flex-wrap justify-center">
        <button
          @click="sendNameArtist"
          :disabled="disabled"
          class="w-90 block mv2 pointer btn dim b f5 fw4"
          :class="{ 'disabled': disabled }"
        >
          {{ $t("app.save") }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import {mapActions, mapGetters} from 'vuex'

  const MODAL_WIDTH = 600

  export default {
    name: 'set-name-artist-modal',
    components: {
      FontAwesomeIcon,
      ClipLoader
    },
    data () {
      return {
        modalWidth: MODAL_WIDTH,
        color: '#808080',
        size: '30px',
        nameError: '',
        nameNeeded: ''
      }
    },
    computed: {
      isLoadingLink () {
        return this.$loading.isLoading('artist setArtisticName')
      },
      ...mapGetters('user', [
        'user'
      ])
    },
    methods: {
      ...mapActions('artist', [
        'setArtisticName'
      ]),
      ...mapActions('user', [
        'editUserType'
      ]),
      beforeOpen (event) {
        this.disabled = false
        this.nameError = ''
        this.nameNeeded = ''
      },
      sendNameArtist () {
        this.disabled = true
        this.editUserType({userType: 1}).then(() => {
          this.setArtisticName({name: this.nameNeeded, user_id: this.user.id, text: '', phrase: ''}).then(() => {
            location.reload()
          }).catch(e => {
            this.$toasted.show(e.message, {type: 'error'})
            this.disabled = false
          })
        }).catch(e => {
          this.$toasted.show(e.message, {type: 'error'})
          this.disabled = false
        })
        this.disabled = false
      },
      validateName () {
        const nameRegex = /^(?=.*[a-zA-Z0-9])\s*([a-zA-Z0-9\s]+)\s*$/g

        if (!nameRegex.test(this.nameNeeded)) {
          this.nameError = 'Nombre vacío'
          this.disabled = true
        } else {
          this.nameError = ''
          this.disabled = false
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .modal {
    z-index: 10000;
  }

  .custom-padding {
  padding-left: 1rem;
  padding-right: 1rem;
}

.custom-padding-input {
  padding-left: 2rem;
  padding-right: 2rem;
}

@media (min-width:300px) and (max-width:600px) {
  .heigthMobile{
    height: 0px !important;
  }
}

.error {
  color: red;
}

.dark-text-color {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/SetNameArtistModal.vue